(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pc-stock-status"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.t4s-product-badge, .t4s-single-product-badge';
  const rules = [
    ['.t4s-badge-soldout, .t4s-badge-sold-out', 'soldout', 0],
    ['.t4s-badge-sale', 'sale', 10],
    ['.t4s-badge-last-chance, .t4s-badge-limited-options', 'stock', 20],
    ['.t4s-badge-preorder, .t4s-badge-preOrder', 'preorder', 25],
    ['.t4s-badge-popular-now', 'popular', 30],
    ['.t4s-badge-bestseller', 'bestseller', 40],
    ['.t4s-badge-glow-in-the-dark', 'glow', 50],
    ['.t4s-badge-new', 'new', 60]
  ];
  const expiry = {popular: Date.parse('2026-11-04T00:00:00Z'), bestseller: Date.parse('2026-11-09T00:00:00Z')};
  const update = container => {
    const badges = Array.from(container.children).filter(el => el.tagName !== 'SCRIPT' && el.tagName !== 'STYLE');
    const ranked = badges.map((el, index) => {
      const rule = rules.find(([selector]) => el.matches(selector));
      return {el, index, key: rule ? rule[1] : el.textContent.trim(), priority: rule ? rule[2] : 55};
    }).sort((a, b) => a.priority - b.priority || a.index - b.index);
    const seen = new Set();
    let shown = 0;
    ranked.forEach(({el, key, priority}, index) => {
      const expired = expiry[key] && Date.now() >= expiry[key];
      const hasText = el.textContent.trim().length > 0;
      const visible = hasText && !expired && !seen.has(key) && shown < 3;
      if (hasText) seen.add(key);
      if (visible) shown++;
      el.style.setProperty('order', String(priority), 'important');
      el.style.setProperty('display', visible ? 'inline-flex' : 'none', 'important');
      el.toggleAttribute('hidden', !visible);
      if (visible) el.removeAttribute('aria-hidden');
      else el.setAttribute('aria-hidden', 'true');
    });
    container.dataset.pcBadgeLimit = '3';
  };
  const start = () => {
    document.querySelectorAll(selector).forEach(update);
    new MutationObserver(records => {
      const containers = new Set();
      records.forEach(record => {
        const parent = record.target instanceof Element ? record.target.closest(selector) : record.target.parentElement?.closest(selector);
        if (parent) containers.add(parent);
        record.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) containers.add(node);
          node.querySelectorAll(selector).forEach(el => containers.add(el));
        });
      });
      containers.forEach(update);
    }).observe(document.documentElement, {childList: true, subtree: true, characterData: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
